/**
 * The password rule the API enforces, repeated here so the form can say it before anyone waits on
 * a request. It must stay in step with MIN_PASSWORD_LENGTH in services/api/src/auth/password.ts.
 */
export const MIN_PASSWORD_LENGTH = 12;

/** The things wrong with a new password and its confirmation, in the words the user reads. */
export function passwordProblems(password: string, confirmation: string): readonly string[] {
  const problems: string[] = [];
  if (password.length < MIN_PASSWORD_LENGTH) {
    problems.push(`Use at least ${MIN_PASSWORD_LENGTH} characters.`);
  }
  if (confirmation !== password) {
    problems.push('The two passwords do not match.');
  }
  return problems;
}
